import { motion } from "framer-motion";
import { Car, Package, Clock, BellRing } from "lucide-react";
import { fileUrl } from "@/lib/apiClient";
import { URGENCY, STATUS } from "@/lib/constants";

export default function RequestCard({ req, onClick, isAdmin }) {
  const u = URGENCY[req.urgency] || URGENCY.stock;
  const s = STATUS[req.status] || STATUS.pending;
  const Icon = u.icon;
  const v = req.vehicle || {};
  const date = new Date(req.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  const notify = isAdmin ? req.notify_admin : req.notify_garage;
  const notifyLabel = isAdmin ? "Réponse garage" : "Nouveau devis";

  return (
    <motion.button
      layout
      whileHover={{ y: -3 }}
      onClick={onClick}
      data-testid={`request-card-${req.id}`}
      className="text-left w-full bg-card border border-border rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow relative"
    >
      {notify && (
        <span data-testid="notify-badge" className="absolute -top-2 -right-2 inline-flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-bold bg-red-600 text-white shadow-md animate-pulse">
          <BellRing className="h-3 w-3" /> {notifyLabel}
        </span>
      )}
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-1">
            <Car className="h-4 w-4 shrink-0" />
            <span className="truncate font-medium text-foreground">{v.marque} {v.modele} {v.annee && `· ${v.annee}`}</span>
          </div>
          <div className="font-heading font-bold text-lg leading-snug flex items-center gap-2">
            <Package className="h-4 w-4 text-blue-600 shrink-0" />
            <span className="truncate">{req.part_name}</span>
          </div>
          {req.part_reference && <div className="text-xs font-mono text-muted-foreground mt-0.5">Réf : {req.part_reference}</div>}
        </div>
        {req.photos && req.photos.length > 0 ? (
          <div className="shrink-0 h-14 w-14 rounded-lg overflow-hidden border border-border">
            <img src={fileUrl(req.photos[0].path)} alt="" className="h-full w-full object-cover" />
          </div>
        ) : (
          <span className={`shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${u.badge}`}>
            <Icon className="h-3.5 w-3.5" />
            {u.short}{req.urgency === "delay" && req.delay_days ? ` ${req.delay_days}j` : ""}
          </span>
        )}
      </div>

      <div className="flex items-center justify-between mt-4 pt-3 border-t border-border">
        <div className="flex items-center gap-2">
          <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${u.badge}`}>
            <Icon className="h-3 w-3" />{u.short}{req.urgency === "delay" && req.delay_days ? ` ${req.delay_days}j` : ""}
          </span>
          <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${s.cls}`}>{s.label}</span>
        </div>
        <span className="text-xs text-muted-foreground flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{date}</span>
      </div>
      {req.quote?.price_ttc != null && (
        <div className="mt-2 text-sm font-semibold text-emerald-600">Devis : {req.quote.price_ttc} € TTC</div>
      )}
    </motion.button>
  );
}
